// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3e5z4","image":"Header_image__VxSl4","name":"Header_name__o8dZ5","info":"Header_info__1U82_","infoRow":"Header_infoRow__2VvbP"};